import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faEllipsisH,
  faEdit,
  faTrashAlt,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Nav,
  Row,
  Form,
  Pagination,
  Card,
  Table,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
  Badge,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import axios from "axios";
import swal from "sweetalert";
import { getTimeOffs, deleteTimeOff } from "../../app/api";
import Loader from "../../components/Loader";
export default () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [timeoff, setTimeOff] = useState([]);
  const [search, setSearch] = useState("");
  const fetchTimeoff = async (currentPage) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getTimeOffs(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage, // Send the current page as a query parameter
          search,
        },
      });
      // console.log(response.data);

      setTimeOff(response.data?.data);
      setTotalPages(response.data?.pagination?.total_pages);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false); // Hide loader after fetching data
    }
  };

  useEffect(() => {
    fetchTimeoff(page);
  }, [page, search]);
  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(deleteTimeOff(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      swal({
        text: response.data.message,
        icon: "success",
      });
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error"
      });
    }
    fetchTimeoff(page);
  };
  return (
    <>
      <div>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
          <div className="d-block  mb-md-0">
            {/* <Breadcrumb
              className="d-none d-md-inline-block"
              listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
            >
              <Breadcrumb.Item>
                <FontAwesomeIcon icon={faHome} />
              </Breadcrumb.Item>
           
              <Breadcrumb.Item active>Time Off</Breadcrumb.Item>
            </Breadcrumb> */}
            <h4 className="mb-0">Time Off Management</h4>
            {/* <p className="mb-0">Your web analytics dashboard template.</p> */}
          </div>
          <Col xs={12} md={4} lg={4} xl={4} className=" mb-sm-2">
              <InputGroup>
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Search"
                />
              </InputGroup>
            </Col>
          <Button
            variant="primary"
            className=" me-2"
            as={Link}
            to={Routes.AddTimeOff.path}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            <span>New</span>
          </Button>
        </div>

        {/* <div className="table-settings mb-4">
          <Row className="justify-content-between align-items-center">
           
          </Row>
        </div> */}
        <Card
          border="light"
          className="table-wrapper table-responsive shadow-sm"
        >
          <Card.Body className="p-0">
            <Table hover className="user-table align-items-center">
              {loading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </div>
              ) : (
                <>
                  <thead>
                    <tr>
                      {/* <th className="border-bottom">ID</th> */}
                      <th className="border-bottom">Vendor Name</th>
                      <th className="border-bottom">Vendor Email</th>

                      <th className="border-bottom">Updated by</th>
                      <th className="border-bottom">Status</th>
                      <th className="border-bottom">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {timeoff.map((time, index) => (
                      <tr key={index}>
                        {/* <td className="fw-normal">{time?.vendor_ID}</td> */}
                        <td>
                          <span className="fw-normal">
                            {" "}
                            <Link
                              className="Link_underline"
                              to={`${Routes.TimeOffDetail.path}/${time.id}`}
                            >
                              {time?.vendor_name}{" "}
                            </Link>
                          </span>
                        </td>
                        <td>
                          <span className="fw-normal">{time?.email}</span>
                        </td>

                        <td>
                          <span className="fw-normal">
                            {time?.updated_by_name}
                          </span>
                        </td>
                        <td>
                          <span className="fw-normal">
                            {" "}
                            <Badge
                              pill
                              bg="primary"
                              style={{
                                padding: "0.4rem 1rem",
                                fontSize: "0.85rem",
                                border: "1px solid #ddd",
                              }}
                            >
                              {time?.status}
                            </Badge>
                          </span>
                        </td>
                        <td>
                          <Dropdown as={ButtonGroup}>
                            <Dropdown.Toggle
                              as={Button}
                              split
                              variant="link"
                              className="text-dark m-0 p-0"
                            >
                              <span className="icon icon-sm">
                                <FontAwesomeIcon
                                  icon={faEllipsisH}
                                  className="icon-dark"
                                />
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item>
                                <Link
                                  className="me-2"
                                  to={`${Routes.TimeOffDetail.path}/${time.id}`}
                                >
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faEye}
                                    className="me-2"
                                  />{" "}
                                  View Details
                                </Link>
                              </Dropdown.Item>
                              <Dropdown.Item>
                                <Link
                                  as={Link}
                                  to={`${Routes.AddTimeOff.path}/${time.id}`}
                                >
                                  <FontAwesomeIcon
                                    icon={faEdit}
                                    className="me-2"
                                  />{" "}
                                  Edit{" "}
                                </Link>
                              </Dropdown.Item>
                              <Dropdown.Item className="text-danger">
                                <div onClick={() => handleDelete(time.id)}>
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    className="me-2"
                                  />{" "}
                                  Remove
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </>
              )}
            </Table>
            <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-center">
              <Nav className="justify-content-center mb-4">
                <Pagination className="mb-2 mb-lg-0">
                  <Pagination.Prev
                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                  />
                  {Array.from({ length: totalPages }, (_, index) => (
                    <Pagination.Item
                      key={index + 1}
                      active={index + 1 === page}
                      onClick={() => setPage(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() =>
                      setPage((prev) => Math.min(prev + 1, totalPages))
                    }
                  />
                </Pagination>
              </Nav>
            </Card.Footer>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
